import { render, staticRenderFns } from "./examenFisicoEmbarazo.vue?vue&type=template&id=cd856394&"
import script from "./examenFisicoEmbarazo.vue?vue&type=script&lang=js&"
export * from "./examenFisicoEmbarazo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports